import verifyIsLoginActive from 'util/verifyIsLoginActive'
import axios from 'shared/http'

const openExternalLink = (url, profileCatalogSelected) => {
  const handleSso = (ssoUrl) => {
    if (!ssoUrl) {
      console.error('SSO URL é inválida ou não foi fornecida.')
      return
    }
    window.open(ssoUrl, '_blank')
  }

  const getUrlAwsMkt = async () => {
    const data = {
      path: url || '',
      profileCatalogSelected: profileCatalogSelected || '',
    }
    const urlEndpoint = '/participants/v1/session-marketplace'
    localStorage.removeItem('be-fly')

    try {
      const response = await axios.post(urlEndpoint, data)

      if (response) {
        handleSso(response)
      }
    } catch (error) {
      console.log(error)
    }
  }

  let isLoginActive = verifyIsLoginActive()

  if (Boolean(isLoginActive)) {
    return url ? handleSso(url) : getUrlAwsMkt()
  }
}

export default openExternalLink
